import { Alert } from '#/types/message';
import './AlertPopup.css';

interface AlertPopupProps {
  alerts: Alert[];
  onClose: () => void;
  inline?: boolean;
}

export function AlertPopup({ alerts, onClose, inline = false }: AlertPopupProps) {
  const sortedAlerts = [...alerts].sort((a, b) => a.level - b.level);

  return (
    <div className={`alert-popup ${inline ? 'inline' : ''}`}>
      {!inline && (
        <div className="alert-header">
          <button onClick={onClose}>×</button>
        </div>
      )}

      <div className="alert-content">
        {sortedAlerts.map((alert, index) => (
          <div key={index} className="alert-item">
            <div className={`alert-type-header alert${alert.level}`}>
              {alert.type}
            </div>
            <div className="alert-message">
              {alert.content.trimStart()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

interface BackdropProps {
  isVisible: boolean;
  onClick: () => void;
}

export function Backdrop({ isVisible, onClick }: BackdropProps) {
  return (
    <div
      className={`backdrop ${isVisible ? 'visible' : ''}`}
      onClick={onClick}
    />
  );
}